import * as angular from 'angular';
import * as _ from "lodash";
import {TaskRequests} from "./task-requests.service";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {TaskAlerts} from "./task-alerts.service";
import {OmsRequestsService} from "../../oms/services/oms-requests.service";
import {SettingsAlertsService} from "../../site-preferences/services/settings-alerts.service";
import {SplitService} from "../../commons/services/split-service.service";
import {TaskModel} from "../models/task.model";
import {ActionReasonModel} from "../../action-reasons/models/action-reason.model";

export class TasksService {

  /* @ngInject */
  constructor(private tasksConstants, private $filter, private $q: IQService, private $mdPanel, private bringozLoaderService: BringozLoaderService,
              private omsRequestsService: OmsRequestsService, private taskRequests: TaskRequests, private splitService: SplitService, private settingsAlertsService: SettingsAlertsService, private taskAlerts: TaskAlerts, private $log) {
  }

  getComplementaryTaskIndex(task, allTasks) {
    const taskServiceIds = task.serviceIds ? task.serviceIds : [task.serviceId];
    return _.findIndex(allTasks, (t: any) => {
      const serviceIds = t.serviceIds ? t.serviceIds : (t.bundleServiceIdList ? t.bundleServiceIdList : [t.serviceId]);
      return t.id !== task.id && this.complementaryServiceIdsTest(taskServiceIds, serviceIds);
    });
  }

  complementaryServiceIdsTest(taskServiceIds, serviceIds) {
    if (!taskServiceIds) {
      taskServiceIds = [];
    }
    if (!serviceIds) {
      serviceIds = [];
    }
    return !!_.intersectionWith(taskServiceIds, serviceIds, _.isEqual).length;

    // var test = false;
    // _.forEach(serviceIds, function(id) {
    //     if (_.indexOf(taskServiceIds, id) !== -1) {
    //         test = true;
    //     }
    // });
    // return test;
  }

  updateInternalTask(task: TaskModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.taskRequests.updateInternalTask(task)
      .then((internalTask) => {
        this.taskAlerts.updateInternalTaskSuccess();
        deferred.resolve(internalTask);
      })
      .catch((error) => {
        this.$log.error(error);
        this.taskAlerts.updateInternalTaskError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getOfflineActions(taskIds: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.taskRequests.getOfflineActions(taskIds)
      .then((internalTask) => {
        deferred.resolve(internalTask);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  editTaskServiceTime(taskId: string, payload: {
    detailedServiceTime?: any,
    legacyServiceTime?: number,
    useLegacyServiceTime: boolean
  }) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.taskRequests.editTaskServiceTime(taskId, payload)
      .then((task: TaskModel) => {
        this.taskAlerts.updateTaskServiceTimeSuccess();
        deferred.resolve(task);
      })
      .catch((error) => {
        this.$log.error(error);
        this.taskAlerts.updateTaskServiceTimeError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  editTaskExtraInfo(taskId: string, extraInfo: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.taskRequests.editTaskExtraInfo(taskId, extraInfo)
      .then((task: TaskModel) => {
        this.taskAlerts.updateTaskExtraInfoSuccess();
        deferred.resolve(task);
      })
      .catch((error) => {
        this.$log.error(error);
        this.taskAlerts.updateTaskExtraInfoError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  revertTaskStatus(taskId: string, revertReason: ActionReasonModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.taskRequests.revertTaskStatus(taskId, revertReason)
      .then((res) => {
        this.taskAlerts.revertTaskStatusSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        this.taskAlerts.revertTaskStatusError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

}

angular
  .module('bringoz.admin.tasks')
  .service('tasksService', TasksService);
